import React = require('react');
export interface IUserItem{
    id: number
    img: string
    name: string
    affinity?: string
    address?: string
    link?:string
    content?:string
}

interface IRemoveItem{
    (id:number):void
}


interface ISharedCompUserListProps {
    editMode:boolean
    title:string
    userList:Array<IUserItem>
    emptyText:string
    removeItem?:IRemoveItem
    classNames?:string
    template?:string
    showJustInnerDiv?:boolean
}

interface ISharedCompUserListState {
}

export class SharedCompUserList extends React.Component<ISharedCompUserListProps, ISharedCompUserListState>{

    private template:string;

    constructor(props:ISharedCompUserListProps){
        super(props);
        this.template = 'default';
        if ( this.props.template !== undefined ) {
            this.template = this.props.template;
        }
    }

    private itemRemoveClickHandler(evt, id:number): void {
        evt.preventDefault();
        this.props.removeItem(id);
    }


    render() {
        var className = 'row bgw ';
        if ( this.props.classNames !== undefined ) {
            className += this.props.classNames;
        }else{
            className += 'shared_comp_user_list';
        }
        if ( this.props.showJustInnerDiv !== undefined && this.props.showJustInnerDiv === true ) {
            className = '';
        }
        return (
            <div className={className}>
                { this.props.title !== null?<h3>
                    { this.props.title }
                </h3>:'' }
                { this.props.userList.length === 0 ?<div>
                    { this.props.emptyText }
                </div>:'' }

                <ul>
                    { this.props.userList.map((item:IUserItem, key)=>{
                        if ( this.template === 'upcoming_event' ) {
                            return (
                                <li key={ key } className="row">
                                    <div className="box">
                                        <div>
                                            { item.link !== undefined?<a href={item.link}>
                                                { item.name }
                                            </a>:item.name }
                                            <img src={item.img} alt="" />

                                            <div className="affinity">
                                                { item.affinity }
                                            </div>
                                            { item.address !== undefined?<div className="address">
                                                { item.address }
                                            </div>:'' }

                                            { item.address !== undefined?<div className="content" dangerouslySetInnerHTML= {{ __html: item.content }}>
                                            </div>:'' }
                                        </div>
                                    </div>
                                </li>
                            );
                        }else{
                            var rowClassName:string = 'box';
                            if ( item.affinity === 'függőben' ) {
                                rowClassName += ' opacity50'
                            }
                             return (
                                <li key={ key } className="row col2">
                                    <div className={ rowClassName }>
                                        <img src={item.img} alt="" />
                                    </div>
                                    <div className={ rowClassName }>
                                        <div>
                                            { item.link !== undefined?<a href={item.link}>
                                                { item.name }
                                            </a>:item.name }

                                            <div className="affinity">
                                                { item.affinity }
                                            </div>
                                            { item.address !== undefined?<div className="address">
                                                { item.address }
                                            </div>:'' }

                                            { item.address !== undefined?<div className="content" dangerouslySetInnerHTML= {{ __html: item.content }}>
                                            </div>:'' }

                                        </div>
                                    </div>
                                    { this.props.editMode === true? <a className="remove_btn" onClick={ e => this.itemRemoveClickHandler(e, item.id) }
                                        >
                                            <i className="remove_icon"></i>
                                        </a>:'' }
                                </li>
                            );
                        }

                    })}
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/event/SharedCompUserList.tsx